module.exports = __webpack_public_path__ + "static/media/radio_on.09c24382.svg";